module.exports = __webpack_public_path__ + "static/media/hackernoon_shells.451d49a9.png";